/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DerivativesOrderType {
    LIMIT = 'Limit',
    MARKET = 'Market',
    STOP_LIMIT = 'StopLimit',
    STOP_MARKET = 'StopMarket',
    TAKE_PROFIT_STOP_LOSS = 'TakeProfitStopLoss',
}
